import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types.js';
const themeSetting = {
    theme: Theme.Flush,
    rankConfig: { sublevelFormat: 'roman', sublevelImages: true },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'flush',
    blockchainAdsConfig: {
        NewVisit: 5225,
        ReturnVisit: 5227,
        ReturnUser: 5228
    },
    brand: 'flush.com',
    brandTitle: 'Flush',
    canonicalUrl: 'https://flush.com',
    cdnBase: 'https://cdn.flush.com',
    cdnBaseFallbacks: ['https://flush.gmcdn.org'],
    cdnTiles: 'https://tiles.flush.com',
    cdnBanners: 'https://images.flush.com/',
    cubePayEnabled: true,
    discordLink: 'https://discord.gg/NMsaxDF3Yu',
    fingerprintjs: 'RRJpTry7JPqVq4qwU8TR',
    fingerprintjsHost: 'fp.flush.com',
    fingerprintVersions: ['v3.9.7'],
    googleAnalytics: 'G-PP80PE9SH9',
    googleClientId: '1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    // googleClientId: '789939130685-qapegigbhg77v6ngmahi8ulp6vpkpn44.apps.googleusercontent.com',
    googleTagManager: 'GTM-KK6X2SQT',
    languageDefault: 'en',
    languages: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
    languagesTiles: ['ja', 'ko'],
    languagesAutoAccept: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
    mixPanelConfig: {
        id: '3e66409ecc2855ef3dba8fe504b9ecde',
        autocapture: true,
        track_pageview: true,
        record_sessions_percent: 0,
        record_heatmap_data: false,
        persistence: 'localStorage',
        debug: true
    },
    intercomId: 'me2zqgio',
    racesEnabled: true,
    supportEmail: 'support@flush.com',
    telegramLink: 'https://t.me/FlushOfficial',
    xLink: 'https://x.com/FlushCasino',
    noIndex: false,
    themePath: 'flush',
    verbiageLabel: 'flush',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'default',
            useMenuItemIndicator: true
        },
        accordion: {
            accordionStyle: 'default'
        },
        auth: {
            useSolidAccentOAuthButton: false,
            showWalletConnect: true,
            useTightModalBodyPadding: false,
            useOffsetModalCloseButton: true
        },
        background: {
            backgroundStyle: 'decorative'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'default'
        },
        cardSwiper: {
            cardSwiperStyle: 'default',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: false
        },
        button: {
            buttonStyle: 'gradient',
            useUppercaseAsDefault: true
        },
        betby: {
            betslipBottom: 60,
            customUI: false
        },
        betfeed: {
            betfeedStyle: 'default',
            usedVerbiage: 'bet_feed',
            enableWeeklyRaceTab: true
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: false,
            withdrawOnlyUsdtMemeCoins: true,
            useInfoStateForWarnings: true,
            showConversionRateDeposit: false,
            showProgressBarBonusMoney: true,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 500,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: true,
            showImageOnDepositBonusOffers: false,
            depositBonusVerbiage: 'casino_bonus',
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'live_casino', percentage: 10 },
                { category: 'originals', percentage: 5 },
                { category: 'table_games', percentage: 10 }
            ],
            showWithdrawalWarningIfNoFunds: false,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'default',
            useCashierHomeScreen: false,
            useSidetabs: true,
            buyCryptoEnabled: true,
            useCashierV4: true,
            useCompactDepositAddressOptionLayout: false,
            extendCashierVerbiageKeysWithBrandLabel: false,
            rememberLastCryptoNetworkSelection: false,
            useVerificationStep: false
        },
        casinoLobby: {
            casinoLobbyStyle: 'default',
            showLiveWins: false
        },
        chat: {
            chatStyle: 'default',
            requiredLanguageVerbiage: 'english'
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'default'
        },
        dropdown: {
            dropdownStyle: 'default',
            useDropdownBackgroundImage: false
        },
        emailVerify: {
            emailVerifyStyle: 'default'
        },
        footer: {
            footerStyle: 'default',
            useEmbeddedShellDecor: true
        },
        games: {
            showRacesLeaderboard: true,
            showNavigationOnMobile: true,
            showLikeButton: true,
            showLogoWhenPlayingDesktop: true,
            showGameInfoModalOnGamePathMobile: true,
            applyPedestalIllustrationHueShift: false,
            useCompactRacesLeaderboardInfoBackdrop: false,
            showRacesLeaderboardPerimeterIllustrations: true
        },
        header: {
            headerStyle: 'default',
            buttonLoginVariant: 'tertiary',
            useTightRewardsToggleHorizontalPadding: true
        },
        helpdesk: {
            useDynamicBonusTerms: true
        },
        home: {
            homeStyle: 'default',
            showBuyCryptoBanner: true,
            showLiveWins: false,
            cryptoBannerStyle: 'default',
            buyCryptoBannerArtStyle: 'framed-chips',
            showAdventCalendarPage: true
        },
        icons: {
            vipHeaderGlyphDarkFill: true,
            statusIconsUseWarmPalette: false,
            expandSectionToggleUsesMintAccent: true,
            navIconPickerAllowRemoteAssets: false,
            navIconPickerUseBundledIconFactories: false
        },
        infoCard: {
            infoCardStyle: 'radial-gradient'
        },
        input: {
            inputStyle: 'default'
        },
        layout: {
            layoutStyle: 'default',
            isContrastTextColor: false,
            useCompactVerticalPagePadding: false,
            useReducedMarginsInHomePage: true,
            useCurrentColorSidebar: false,
            useReferralIconAnimated: true,
            useNewIcons: false,
            useRemoteIcons: false,
            showCryptoPriceDropdown: true,
            showNotInCatalogGames: false,
            showUpdownGameDropdown: false,
            useV2LiveWins: true,
            useReferralBannerOnlyImageCustom: false,
            usePromoItemContentCustom: false,
            useCentralButtonOnMobileMenu: true,
            selectedCentralButton: 'rewards',
            centralButtonDepositThresholdUsd: 20,
            sectionIconSize: 24,
            useExpandedRankPresentation: false,
            useAlternateMobileSidebarBackdrop: false,
            embedWebSiteOrganizationJsonLd: true
        },
        liveWins: {
            liveWinsStyle: 'default',
            usedVerbiage: 'big_wins',
            useSpecialWinCards: true
        },
        loading: {
            useLottie: true,
            publicInitPageLoadDisplayFor: 0,
            playerInitPageLoadDisplayFor: 3000
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded'
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'gradient-framed'
        },
        walletDropdown: {
            showBalancePreferenceToggles: true
        },
        notifications: {
            notificationsStyle: 'default',
            useBorderedPlayerNotificationsIcon: false,
            useGradientPublicNotificationsIcon: false,
            useExtendedDepositNotificationTitles: false
        },
        toasts: {
            toastsStyle: 'default',
            isLocalIcon: false
        },
        tooltip: {
            tooltipStyle: 'default'
        },
        profileModal: {
            profileModalStyle: 'default',
            showFavouriteSection: true,
            useStarsBackgroundOnFavouriteToken: true,
            useTokenArtBackgroundOnDesktop: false,
            useCompactFavouriteTokenMobileCard: false
        },
        promotions: {
            showExpiredPromotions: true,
            useAspectRatioBoxDetailCustom: false,
            promoBannerStyle: 'default',
            promotionsStyle: 'default',
            showActionButton: true,
            highlightTitleFirstWord: false
        },
        provider: {
            providerStyle: 'default',
            useSolidPrimaryGameCountBadge: false
        },
        referral: {
            referralDashboardBannerType: 'html',
            showContainerInFAQ: true,
            faqTitleStyle: 'badge',
            faqVisibilityPreset: 'hide_limits_and_terms',
            referralDashboardFaqVisibilityPreset: 'hide_getting_started',
            accordionGlassStyle: true,
            rulesCardsStyle: 'glass',
            commissionLevelsPrimaryTierBadgeTextColor: 'secondary',
            rulesFootnoteMuted: true,
            highlightStepTitles: false,
            highlightReferralDashboardBannerTitle: false,
            rankProgressPalette: 'cool',
            usePrefixedVerbiageKeys: false,
            shareModalStyle: 'basic',
            shareMessageVariant: 'default',
            shareBannerStyle: 'classic',
            referralDashboardBannerStyle: 'classic'
        },
        transparency: {
            enabled: true,
            disabledOnProd: true
        },
        affiliates: {
            enabled: true,
            usePrefixedVerbiageKeys: false,
            showEarningsCardBackground: true,
            showExtendedPartnerTestimonials: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'default',
            useComfortableRewardsTimerLabels: false,
            showSeasonalRewardsCampaignTabs: true
        },
        seoText: {
            style: 'default'
        },
        settings: {
            settingsStyle: 'default',
            showWalletTab: true
        },
        sidebar: {
            sidebarStyle: 'default',
            showLuckyDip: true,
            showBanner: false
        },
        table: {
            tableStyle: 'default'
        },
        tabs: {
            tabsStyle: 'default',
            useCompactTabStripRadius: false,
            tabButtonsDefaultVariant: 'secondary'
        },
        text: {
            successTextUsesWarmTone: false
        },
        toggle: {
            toggleStyle: 'default'
        },
        topSection: {
            casinoTopSectionStyle: 'default',
            highlightTitleFirstWord: false
        },
        transactions: {
            transactionsStyle: 'default',
            useSegmentedTabs: false,
            useElevatedRows: false,
            showEmptyStateIllustration: true
        },
        vip: {
            vipDashboardStyle: 'default',
            vipAboutStyle: 'default',
            vipAboutStylePreview: 'default',
            useMarkdownFaqs: true,
            heroCardOpacity: 0.5,
            rewardsTableLayout: 'detailed',
            rewardsProgressPalette: 'cool',
            includeWageringRequirementRow: false,
            reorderPrimaryBenefitCards: false,
            testimonialsHeaderStyle: 'badge',
            useCompactTestimonialsCardHeight: false,
            faqListLength: 'full',
            usePrefixedVerbiageKeys: false,
            assetSet: 'classic',
            negativeBadgeTone: 'coral',
            showRankPrefixBeforeDisplayName: false,
            useAccentPendingTotalsBadge: false,
            useBorderOnMiniVipCalendarCard: false,
            useCompactClubOverviewSectionHeights: false,
            useCompactRoyaltyBannerTypography: false,
            useExpandedRoyaltyBannerSectionSpacing: false,
            useGradientVipCalendarDateHeader: false,
            useTallerRoyaltyBannerOnNarrowScreens: false,
            showRoyaltyBannerInDashboard: true,
            calendarSummaryLabel: 'pending',
            includeRaceInRakebackBreakdown: true,
            showVipRewardTooltips: true,
            monthlyRewardsTooltipStyle: 'expanded',
            useClassicVipCalendarCardChrome: true,
            rakeboostProgressTone: 'mint'
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'default'
        },
        activeEventTheme: {
            eventID: 'christmas2025',
            eventStartDate: '2025-11-21T00:00:00Z',
            eventEndDate: '2025-12-31T23:59:59Z',
            config: {
                pageBackground: false,
                buttonAddon: true,
                navbarBackground: true,
                sidebarBackground: true,
                divider: true,
                customLogo: true
            }
        }
    }
};
const flushCanonicalHelpcenterHref = `${themeSetting.canonicalUrl}/helpcenter`;
export const flushSupportChatApiUrl = 'https://chat-service.net.infinitro.dev/';
export const flushSupportChatApiUrlProd = 'https://chat-service.prod.infinitro.dev/';
const themeSettings = [
    {
        ...themeSetting,
        brand: 'gamma.flush.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        fingerprintjsHost: 'fp.flush.com',
        languages: [
            'ar',
            'cs',
            'de',
            'en',
            'es',
            'fr',
            'id',
            'it',
            'ja',
            'ko',
            'ms',
            'pt',
            'ru',
            'tr',
            'vi',
            'zh'
        ],
        languagesTiles: ['ja', 'ko', 'tr'],
        betbyEnabled: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush.com',
        brand: 'next.flush.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush.casino',
        brand: 'flush.casino',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush1001.com',
        brand: 'flush1001.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush1002.com',
        brand: 'flush1002.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flush.meme',
        brand: 'flush.meme',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        fingerprintjsHost: 'fp.flushmeme.com',
        brand: 'flushmeme.com',
        helpcenterHref: flushCanonicalHelpcenterHref,
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'alpha-flush.previewenv.net',
        languages: [
            'ar',
            'cs',
            'de',
            'en',
            'es',
            'fr',
            'id',
            'it',
            'ja',
            'ko',
            'ms',
            'pt',
            'ru',
            'tr',
            'vi',
            'zh'
        ],
        languagesTiles: ['ja', 'ko', 'tr'],
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'localhost',
        languages: ['en', 'cs', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'ru', 'zh'],
        noIndex: true
    }
];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getThemeSetting = (domain, fullDomain) => {
    return themeSettings.find((s) => fullDomain.includes(s.brand)) ?? themeSetting;
};
export const endpointSettings = [];
const defaultEndpoint = {
    name: 'flush',
    theme: Theme.Flush,
    betbyBrandId: '2511187282057371656',
    betbyEnabled: true,
    betbyScriptUrl: 'https://flush.sptpub.com/bt-renderer.min.js',
    base: 'fc133b1e-d9fa-4f82-8ea6-ab4b8bd06814.api-access.org',
    baseCurrency: 'USD',
    baseCurrencySymbol: '$',
    baseCurrencyDigits: 2,
    realm: 'prod-flush',
    catalogFilter: CatalogFilter.ReleaseGames,
    endpointType: EndpointType.Production,
    reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
    supportChatApiUrl: flushSupportChatApiUrlProd,
    telegramAuthBot: 'FlushComBot'
};
// todo: read alt endpoints from S3, get player endpoints from authentication
export const endpointSetting = (appMode, domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain) => {
    switch (fullDomain) {
        case 'flush1001.com':
        case 'flush1002.com':
        case 'flush.casino':
        case 'flush.meme':
        case 'flushmeme.com':
        case 'next.flush.com':
        case 'gamma.flush.com':
            return {
                ...defaultEndpoint,
                base: 'faa8806b-697a-40c0-8c20-9c2b06a4ca29.api-access.org'
            };
    }
    switch (appMode) {
        case AppMode.Player:
            return {
                ...defaultEndpoint,
                base: 'f921f7d6-344b-4085-b1b3-f47e485a012c.api-access.org'
            };
    }
    return {
        ...defaultEndpoint,
        base: 'fc133b1e-d9fa-4f82-8ea6-ab4b8bd06814.api-access.org'
    };
};
export { themeSetting as flushThemeSetting, themeSettings as flushThemeSettings };
